module.exports = __webpack_public_path__ + "img/cesarabaroa.b957bc18.jpg";